import React, { Component } from 'react';

class GoogleMap extends Component {
  componentDidMount() {

new window.google.maps.Map(this.refs.map, {
            zoom:12,
            center: {
                lat: this.props.lat,
                lng: this.props.lon
            }
        });
  }

  render() {
  return <div className="card-image" ref="map">  ></div>;
  }

}

export default GoogleMap;



// WEBPACK FOOTER //
// ./src/components/google_map.js